<template>
  <div id="enterprise-card4">
    <div class="enterprise-card4-list">
      <div
        class="enterprise-card4-item"
        v-for="(item, index) in companyEmilList"
        :key="index"
      >
        <div class="emil">{{ item.value }}</div>
        <div class="tags">
          <div class="tag">{{ item.remark }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    companyEmilList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="less" scoped>
#enterprise-card4 {
  width: 100%;
  .enterprise-card4-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .enterprise-card4-item {
      width: 32%;
      margin-bottom: 10px;
      box-shadow: 0 0 8px #0000001a;
      border-radius: 4px;
      padding: 16px;
      margin: 5px;
      box-sizing: border-box;
      .emil {
        width: 100%;
        text-align: left;
        font-size: 18px;
        font-weight: 500;
        line-height: 18px;
        color: #111a34;
        white-space: nowrap;
      }
      .tags {
        width: 100%;
        display: flex;
        margin-top: 8px;
        .tag {
          height: 16px;
          font-size: 14px;
          margin-right: 4px;
          line-height: 16px;
          color: #327bf9;
          background: #eaf2ff;
          border-radius: 2px;
          padding: 0 4px;
          box-sizing: border-box;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
